import { emptyArr } from 'util/arrays'

export const selectOrderedFolderIds = state => state.folders.ordered || emptyArr
